import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Button, Icon, Pill, Text } from '@components/base'
import { FadeFromBottomModal } from '@components'
import { useGoBack } from '@src/utils/navigation'
import { UiPillFill, UiPillSize } from '@src/types'

export const ChatWelcomeModal = () => {
  const styles = useStyleSheet(themedStyles)
  const goBack = useGoBack()

  return (
    <FadeFromBottomModal closeModal={goBack} closeAccessory="none" contentStyles={styles.container}>
      <Icon name="sparkle" style={styles.icon} />
      <View style={styles.titleContainer}>
        <Text type="title-2">Welcome To Nora AI</Text>
        <Pill text="Beta" size={UiPillSize.S} fill={UiPillFill.Citron} style={styles.betaTag} />
      </View>
      <Text type="regular" style={styles.text}>
        Nora, as an AI, may occasionally provide inaccurate facts. If you notice inaccuracies,
        please contact support.
      </Text>

      <Button
        type="primary"
        size="block"
        onPress={goBack}
        accessibilityLabel="Continue"
        style={styles.button}
      >
        Continue
      </Button>
    </FadeFromBottomModal>
  )
}

const themedStyles = StyleService.create({
  container: {
    alignItems: 'center',
  },
  icon: {
    marginTop: 8,
    marginBottom: 16,
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  betaTag: {
    marginLeft: 8,
  },
  text: {
    textAlign: 'center',
    marginBottom: 16,
  },
  button: {
    marginTop: 16,
  },
})
